import { createSlice } from '@reduxjs/toolkit';
import { addNewFeature, editFeature, getAllFeatures } from './featuresService';

const initialState = {
  allFeatures: {
    isFeaturesLoading: null,
    isFeaturesSuccess: null,
    featuresMessage: null,
    pageCount: 0,
    features: [],
  },
  newFeature: {
    isFeatureCreating: null,
    isFeatureCreated: null,
    featureCreationMsg: null,
  },

  editedFeature: {
    isEditingFeature: null,
    isFeatureEdited: null,
    featureEditedMsg: null
  }
};

const featuresSlice = createSlice({
  name: 'feature',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllFeatures.pending, (state) => {
        state.allFeatures = {
          ...initialState.allFeatures, // Reset to initial state
          isFeaturesLoading: true,
          featuresMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllFeatures.rejected, (state, action) => {
        state.allFeatures = {
          ...initialState.allFeatures,
          isFeaturesLoading: false,
          isFeaturesSuccess: false,
          featuresMessage: action.payload || 'Error occurred while fetching features',
        };
      })

      // FULFILLED
      .addCase(getAllFeatures.fulfilled, (state, action) => {
        state.allFeatures = {
          ...initialState.allFeatures,
          isFeaturesLoading: false,
          isFeaturesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          features: action.payload.data || [],
        };
      });

    //Feature creating
    builder
      .addCase(addNewFeature.pending, (state) => {
        state.newFeature = {
          ...initialState.newFeature, // Reset to initial state
          isFeatureCreating: true,
          featureCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewFeature.rejected, (state, action) => {
        state.newFeature = {
          ...initialState.newFeature,
          isFeatureCreating: false,
          isFeatureCreated: false,
          featureCreationMsg: action.payload || 'Error occurred while creating the feature.',
        };
      })

      // FULFILLED
      .addCase(addNewFeature.fulfilled, (state, action) => {
        state.newFeature = {
          ...initialState.newFeature,
          isFeatureCreating: false,
          isFeatureCreated: true,
          featureCreationMsg: action.payload || 'Successfully created the feature.',
        };
      });

    //Feature editing
    builder
      .addCase(editFeature.pending, (state) => {
        state.editedFeature = {
          ...initialState.editedFeature, // Reset to initial state
          isEditingFeature: true,
          featureEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editFeature.rejected, (state, action) => {
        state.editedFeature = {
          ...initialState.editedFeature, // Reset to initial state
          isEditingFeature: false,
          isFeatureEdited: false,
          featureEditedMsg: action.payload || 'Error occurred while editing the feature.',
        };
      })

      // FULFILLED
      .addCase(editFeature.fulfilled, (state, action) => {
        state.editedFeature = {
          ...initialState.editedFeature, // Reset to initial state
          isEditingFeature: false,
          isFeatureEdited: true,
          featureEditedMsg: action.payload || 'Successfully edited the feature.',
        };
      });
  },
});

export default featuresSlice.reducer;
